import type { FC } from "react";
import { ChevronDownIcon, ChevronLeftIcon, ChevronRightIcon, ChevronUpIcon } from "@heroicons/react/20/solid";
import { cn } from "@/lib/cn";

type SlidePanelToggleProps = {
  isOpen: boolean;
  onToggle: () => void;
};

export const SlidePanelToggle: FC<SlidePanelToggleProps> = ({ isOpen, onToggle }) => (
  <button
    type="button"
    onClick={onToggle}
    aria-expanded={isOpen}
    aria-label={isOpen ? "Hide the practitioner list" : "Show the practitioner list"}
    className={cn(
      "absolute z-20 flex cursor-pointer items-center justify-center bg-neutral-white text-neutral-black transition-all duration-300 hover:bg-brand-dark-blue hover:text-white",
      "top-full left-1/2 -translate-x-1/2 rounded-b-small px-16 py-4",
      "lg:top-1/2 lg:left-full lg:translate-x-0 lg:-translate-y-1/2 lg:rounded-r-small lg:rounded-bl-none lg:px-4 lg:py-16",
    )}
  >
    {isOpen ? (
      <>
        <ChevronUpIcon className="size-24 lg:hidden" />
        <ChevronLeftIcon className="hidden size-24 lg:block" />
      </>
    ) : (
      <>
        <ChevronDownIcon className="size-24 lg:hidden" />
        <ChevronRightIcon className="hidden size-24 lg:block" />
      </>
    )}
  </button>
);
